import { useState, useEffect, useCallback } from "react";
import { fetchFTSReports, removeFTSReport } from "../../../helpers/fulltextScreening";

export const useFullScreening = (maxRows = Number.MAX_SAFE_INTEGER) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [error, setError] = useState(null);

    const loadReports = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        
        try {
            const response = await fetchFTSReports(1, maxRows, '', '');
            setData(response.data?.events || []);
        } catch (err) {
            console.error("Error loading FTS reports:", err);
            setError(err.message || "Failed to load reports");
        } finally {
            setIsLoading(false);
        }
    }, [maxRows]);

    const deleteReport = useCallback(async (reportId) => {
        setIsDeleting(true);
        
        try {
            const response = await removeFTSReport(reportId);
            
            if (response.data.success) {
                setData(prevData => prevData.filter(item => 
                    item.id !== reportId && item.SK !== reportId
                ));
                return { success: true };
            }
            
            throw new Error("Failed to delete report");
        } catch (err) {
            console.error("Error deleting report:", err);
            return { success: false, error: err };
        } finally {
            setIsDeleting(false);
        }
    }, []);

    useEffect(() => {
        loadReports();
    }, [loadReports]);

    return {
        data,
        isLoading,
        isDeleting,
        error,
        loadReports,
        deleteReport,
    };
};